import { render, staticRenderFns } from "./Pesok.vue?vue&type=template&id=f96ac498"
import script from "./Pesok.vue?vue&type=script&lang=js"
export * from "./Pesok.vue?vue&type=script&lang=js"
import style0 from "./Pesok.vue?vue&type=style&index=0&id=f96ac498&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports